// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { string, bool, node, func } from 'prop-types';
import { ComposedModal, ModalBody, ModalHeader, Button } from '@carbon/react';
import { useTranslation } from 'react-i18next';

import ModalManager from 'Containers/ModalManager/ModalManager';
import { NETWORK_ONE_DISTRIBUTION } from 'Constants';

import Logo from 'Assets/images/logo-nod@2x.png';

const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem !important;
  text-align: center;

  p {
    padding-right: 0 !important;
    white-space: pre-line;
  }

  img {
    transform: scale(0.5);
  }

  button {
    min-width: 0;
    width: 100%;
    height: 50px;
    padding: 0;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    border-color: inherit;
  }
`;

const ErrorBoundaryComponent = ({ hasError, error, hasCustomError, clearError, children }) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalManager open={ hasError }>
        <ComposedModal size="sm" className="ErrorBoundaryModal">
          <ModalHeader />
          <StyledModalBody>
            <img src={ Logo } alt={ NETWORK_ONE_DISTRIBUTION } />
            { hasCustomError ? (
              <>
                <h2>{t('errors.genericErrorMessage')}</h2>
                { error && <p>{ error?.message || error }</p> }
              </>
            ) : (
              <>
                <h2>{t('errors.genericErrorMessage')}</h2>
                { error && <p>{ error?.message || error }</p> }
              </>
            )}
            { error?.status >= 500 && (
              <Button
                kind="danger"
                onClick={ () => window.location.reload(false) }
              >
                { t('errors.reload') }
              </Button>
            ) }
            <Button
              kind="danger"
              onClick={ clearError }
            >
              { t('errors.ok') }
            </Button>
          </StyledModalBody>
        </ComposedModal>
      </ModalManager>
      { children }
    </>
  );
};

ErrorBoundaryComponent.propTypes = {
  error: string,
  hasError: bool,
  hasCustomError: bool,
  clearError: func,
  children: node
};

export default ErrorBoundaryComponent;
